import { render, staticRenderFns } from "./addInstock.vue?vue&type=template&id=7b75474b&scoped=true&"
import script from "./addInstock.vue?vue&type=script&lang=js&"
export * from "./addInstock.vue?vue&type=script&lang=js&"
import style0 from "./addInstock.vue?vue&type=style&index=0&id=7b75474b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b75474b",
  null
  
)

export default component.exports